const STORAGE_KEY = 'syrakis_session_hint';

export function setSessionHint(user, expiresIn = 28800) {
  if (typeof window === 'undefined') return null;
  const current = getSessionHint();
  const hint = {
    session_key: window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    role: user?.role || current?.role || '',
    user: user ? { id: user.id, email: user.email, nombre: user.nombre } : current?.user || null,
    expires_at: Date.now() + (Number(expiresIn) || 28800) * 1000,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(hint));
  return hint;
}

export function getSessionHint() {
  if (typeof window === 'undefined') return null;
  try {
    const hint = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (!hint || !hint.session_key || Number(hint.expires_at) <= Date.now()) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return hint;
  } catch (_error) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearSessionHint() {
  if (typeof window !== 'undefined') localStorage.removeItem(STORAGE_KEY);
}
